import { useEffect } from 'react'
import { EParamSortOrder, EOrgType } from '@unfoldrtech/portal-mic'
import {
  EChannelTypeGlobal,
  EReportColumnHeader,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { useFeatureFlags } from '../../../hooks/useFeatureFlags'
import { PORTAL_FF_REPORTING_METRICS_OMIT } from '../../../utils/constants/featureFlags'
import { TGlobalTables } from '../models'

const getDefaultSortByForAdvertiser = (
  channelType: EChannelTypeGlobal | undefined,
  omittedMetrics: string[]
) => {
  if (channelType === EChannelTypeGlobal.SponsoredProduct) {
    if (omittedMetrics.includes(EReportColumnHeader.Revenue)) {
      return EReportColumnHeader.Carts
    }

    return EReportColumnHeader.Revenue
  }

  if (omittedMetrics.includes(EReportColumnHeader.Impressions)) {
    return EReportColumnHeader.Name
  }

  return EReportColumnHeader.Impressions
}

export const useGetDefaultSortBy = ({
  sortBy,
  sortOrder,
  setSortBy,
  setSortOrder,
  orgType,
  channelType,
  whitelistedMetrics,
}: {
  sortBy?: string
  sortOrder?: string
  setSortBy: (newSortBy?: string) => void
  setSortOrder: (newSortOrder?: EParamSortOrder) => void
  orgType: EOrgType
  channelType?: EChannelTypeGlobal
  whitelistedMetrics?: TGlobalTables
}) => {
  const featureFlags = useFeatureFlags()
  const omittedMetrics = featureFlags[PORTAL_FF_REPORTING_METRICS_OMIT] || []

  useEffect(() => {
    // Reset the sortBy on channelType change
    setSortBy(undefined)
  }, [channelType])

  useEffect(() => {
    if (sortBy) return

    if (sortOrder !== EParamSortOrder.Desc) {
      setSortOrder(EParamSortOrder.Desc)
    }

    if (orgType === EOrgType.Advertiser) {
      const advertiserSortBy = getDefaultSortByForAdvertiser(
        channelType,
        omittedMetrics
      )
      setSortBy(advertiserSortBy)

      if (
        advertiserSortBy === EReportColumnHeader.Name &&
        omittedMetrics.includes(EReportColumnHeader.Impressions)
      ) {
        setSortOrder(EParamSortOrder.Asc)
      }
    } else if (orgType === EOrgType.Retailer) {
      if (
        whitelistedMetrics &&
        !whitelistedMetrics.includes(EReportColumnHeader.Costs)
      ) {
        setSortBy(EReportColumnHeader.Impressions)
      } else {
        setSortBy(EReportColumnHeader.Costs)
      }
    }
  }, [sortBy, sortOrder, orgType, channelType])
}
